import {createActions} from 'client/framework';

export default createActions(null, ['SET_TASK', 'SET_ARGS', 'RUN', 'RESET_STORE']);
